import axios from "axios";
import { baseApi } from "../Config";
import { nonRestrictedApis } from "./nonRestrictedApis";

export const actionHandler = (payload) => {
  // Headers
  axios.defaults.headers["Content-Type"] = "application/json";
  axios.defaults.headers["Access-Control-Allow-Origin"] = "*";

  // Token for authentication
  const cleanUrl = payload.url.split("?")[0];

  // Get token from localStorage
  const accessToken = localStorage.getItem("NpoToken");

  // If token exists and the URL is NOT in nonRestrictedApis
  if (accessToken) {
    if (!nonRestrictedApis.includes(cleanUrl)) {
      console.log("Restricted API:", cleanUrl);
      axios.defaults.headers.common.Authorization = `Basic ${accessToken}`;
    } else {
      console.log("Non-restricted API:", cleanUrl);
    }
  }
  payload.baseURL = baseApi;

  return new Promise((resolve, reject) => {
    axios(payload)
      .then((response) => {
        if (
          response.data.status_code >= 200 ||
          (response.status >= 200 && response.data.status_code < 300) ||
          response.status < 300
        ) {
          resolve(response);
        } else {
          reject(response);
        }
      })
      .catch((err) => {
        reject(err);
      });
  });
};
axios.interceptors.response.use(undefined, (err) => {
  let statusCode = err.status_code;
  if (statusCode === undefined) {
    // Server needs to specify CORS headers in the response
    // Basically `ACCESS-CONTROL-ALLOW-ORIGIN: *`
    // Otherwise, these kinda issues happen
    const lineSplit = err.toString().split("\n")[0].split(" ");
    statusCode = lineSplit[lineSplit.length - 1];
  }
  return new Promise(() => {
    if (statusCode === 401) {
      // Got an unauthorized, logout the user
      localStorage.clear();
      window.location.pathname = "/loginDataUser";
    }
    throw err;
  });
});
